export default __webpack_public_path__ + "static/char-s-54-ko-0e3e42cbb0a7b5253416988a4a21fffc.png";